import { TableModel } from './extraction-models/extraction-models';
import { ExtractionPage } from './domain-extraction-specifications';
import { DocumentClassKey } from '@ps-gui/claims-terminal-shared';

export enum AppViewType {
  AUFTRAG_ASSIGNMENT = 'AUFTRAG_ASSIGNMENT',
  ERFASSUNG_BEHANDLER = 'ERFASSUNG_BEHANDLER',
  EXTRACTION = 'EXTRACTION',
  TABLE_ROW_CLASSIFICATION = 'TABLE_ROW_CLASSIFICATION',
  CONSOLIDATION = 'CONSOLIDATION',
}

export interface AppViewBase<T extends AppViewType> {
  shouldBeSkipped: () => Promise<boolean>;
  type: T;
}

export type ErfassungBehandlerView = AppViewBase<AppViewType.ERFASSUNG_BEHANDLER>;

export type AuftragAssignmentView = AppViewBase<AppViewType.AUFTRAG_ASSIGNMENT>;

export interface ExtractionView extends AppViewBase<AppViewType.EXTRACTION> {
  documentId: string;
  documentClass: DocumentClassKey;
  page: ExtractionPage;
}

export interface TableRowClassificationView extends AppViewBase<AppViewType.TABLE_ROW_CLASSIFICATION> {
  documentId: string;
  documentClass: DocumentClassKey;
  tableModel: TableModel;
}

export interface ConsolidationView extends AppViewBase<AppViewType.CONSOLIDATION> {
  splitDocumentId: string | undefined;
  splitEntityIndex: number;
}

export type DocumentView = ExtractionView | TableRowClassificationView;
export type AppView =
  | AuftragAssignmentView
  | ErfassungBehandlerView
  | ExtractionView
  | TableRowClassificationView
  | ConsolidationView;

export const isDocumentView = (view: AppView): view is DocumentView =>
  isExtractionView(view) || isTableRowClassificationView(view);

export const isErfasseBehandlerView = (view: AppView): view is ErfassungBehandlerView =>
  view.type === AppViewType.ERFASSUNG_BEHANDLER;

export const isAuftragAssignmentView = (view: AppView): view is AuftragAssignmentView =>
  view.type === AppViewType.AUFTRAG_ASSIGNMENT;

export const isExtractionView = (view: AppView): view is ExtractionView =>
  view.type === AppViewType.EXTRACTION;

export const isTableRowClassificationView = (view: AppView): view is TableRowClassificationView =>
  view.type === AppViewType.TABLE_ROW_CLASSIFICATION;

export const isConsolidationView = (view: AppView): view is ConsolidationView =>
  view.type === AppViewType.CONSOLIDATION;
